/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  section: {
    marginLeft: "46px",
  },
  questionNum: {
    color: "#fff",
    fontWeight: "bold",
  },
  bulletPoint: {
    marginTop: "-3px",
    marginLeft: "5px",
    float: "left",
  },
  article: {
    paddingBottom: "10px",
  },
  bulletCol: {
    backgroundColor: "#1080A2",
    minHeight: "26px",
    minWidth: "26px",
    borderRadius: "50%",
  },
  mandatory: {
    color: "#B01403",
  },
}));

function SurveySection({ title, mandatory, number, error, children }) {
  const classes = useStyles();

  const displayTitle = (title, mandatory) => {
    if (mandatory) {
      return (
        <>
          <span>{title}</span>
          &nbsp;
          <span className={classes.mandatory}>*</span>
        </>
      );
    }
    return title;
  };
  return (
    <>
      <article className={classes.article} aria-hidden>
        <div className={`fa-stack ${classes.bulletPoint}`}>
          <p
            className={`fa-stack-1x ${classes.questionNum} ${classes.bulletCol}`}
          >
            {number}
          </p>
        </div>
        <section className={classes.section}>
          <header>{displayTitle(title, mandatory)}</header>
          <div className={`text-danger ${classes.mandatory}`}>{error}</div>
        </section>
      </article>
      <article className={classes.article}>
        <section className={classes.section}>{children}</section>
      </article>
    </>
  );
}

SurveySection.propTypes = {
  children: PropTypes.node,
  number: PropTypes.number,
  title: PropTypes.string,
  mandatory: PropTypes.bool,
  error: PropTypes.string,
};

export default SurveySection;
